export const mapUserDetailsToComment = (comment, userItem) => {
  const { displayName, email, id } = userItem;
  return `${comment}.
    User details [Display name: ${displayName}, Email: ${email}, Id: ${id}]`;
};

export default {
  mapUserDetailsToComment,
};
